import { Injectable } from '@angular/core';

@Injectable()
export class UserService {

  private _userModel?: UserModel;
  get userModel(): UserModel {
    if (!this._userModel) {
      this._userModel = new UserModel();
    }
    return this._userModel;
  }

  private _username: String;
  get username(): String {
    return this._username;
  }

  private _authorities: String[] = [];
  get authorities(): String[] {
    return this._authorities;
  }

  setJwtObject(jwtObject: any) {
    this._username = jwtObject.user_name;
    this._authorities = jwtObject.authorities;
  }

  set userModel(userModel: UserModel) {
    this._userModel = userModel;
  }

  setUserModel(userModel: any) {
    this._userModel = new UserModel(userModel);
  }
}

export interface User {
  userId?: string;
  username?: string;
  password?: string;
}

export class UserModel {
  userId: string;
  userName: string;
  email: string;

  constructor(jwtObject?: any) {
    this.userId = jwtObject ? jwtObject['01'] : '';
    this.userName = jwtObject ? jwtObject['02'] : '';
  }
}
